import appStations from "../../views/appRoutes/stations.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "stations";
  const params = [
    "page",
    "limit",
    "district",
    "sort",
    "is_dynamic",
    "private_bus_request",
  ];

  $stateProvider.state("stations", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appStations,
      },
    },
    reloadOnSearch: false,
    data: { title: "Stations" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/stations/stations.urls.js